import React from 'react';
import { jwtDecode } from 'jwt-decode';
import PageForm from "components/pageForm/PageForm";

const Dashboard = () => {
    // Récupérer l'userId depuis le JWT stocké dans localStorage
    const getUserId = () => {
        const token = localStorage.getItem('xsrfToken');
        if (!token) return '';
        try {
            const decoded = jwtDecode(token);
            return decoded?.id || '';
        } catch {
            return '';
        }
    };

    const userId = getUserId();
    const retoolUrl = `https://jobbiz.retool.com/embedded/public/44e5f176-2c44-493b-9f1b-d82718d921b9?userId=${userId}`;

    return (
        <>
            <PageForm>
                {/* Retool Dashboard - Prend tout l'espace disponible sous la navbar */}
                <div className="h-full w-full flex flex-col">
                    <iframe
                        src={retoolUrl}
                        width="100%"
                        height="100%"
                        style={{ border: 'none', flex: 1 }}
                        title="Tableau de bord Retool"
                    />
                </div>
            </PageForm>
        </>
    );
};

export default Dashboard;
